import store from '@/store';

import { INITIALIZE_FROM_COOKIES_AC, SET_REDIRECT_ACT } from '@/store/auth/actions.type';
import Main from '@/modules/main/Main.vue';
import Header from '@/modules/header/Header.vue';

import compraConjunta from './compra-conjunta';

const beforeEnterAuth = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    if (store.getters.tokenFromStorage) {
      store.dispatch(INITIALIZE_FROM_COOKIES_AC);
      return next();
    }
    store.dispatch(SET_REDIRECT_ACT, to.fullPath);
    return next('/login');
  }
  return next();
};

export default {
  path: '/',
  name: 'main',
  redirect: { name: 'main.indicadores-marketplace' },
  components: {
    default: Main,
    header: Header,
  },
  children: [
    {
      path: 'meu-painel',
      name: 'main.meu-painel',
      components: {
        default: () => import(/* webpackChunkName: "meu-painel" */ '@/modules/meu-painel/MeuPainel.vue'),
      },
    },
    {
      path: 'indicadores-catalogo',
      name: 'main.indicadores-catalogo',
      components: {
        default: () => import(/* webpackChunkName: "indicadores-catalogo" */ '@/modules/indicadores-catalogo/IndicadoresCatalogo.vue'),
      },
    },
    {
      path: 'cotacoes',
      name: 'main.cotacoes',
      components: {
        default: () => import(/* webpackChunkName: "lista-cotacao" */ '@/modules/cotacoes/ListagemCotacao.vue'),
      },
    },
    {
      path: 'cotacao/:id',
      name: 'main.cotacao.detalhes',
      components: {
        default: () => import(/* webpackChunkName: "cotacao" */ '@/modules/cotacoes/detalhes/Cotacao.vue'),
      },
    },
    {
      path: 'cotacao/:id/minha-resposta',
      name: 'main.cotacao.minharesposta',
      components: {
        default: () => import(/* webpackChunkName: "minha-resposta" */ '@/modules/cotacoes/resposta/minha-resposta/MinhaResposta.vue'),
      },
    },
    {
      path: 'cotacao/:id/feedback',
      name: 'main.cotacao.feedback',
      components: {
        default: () => import(/* webpackChunkName: "feedback" */ '@/modules/feedback/FeedbackPage.vue'),
      },
    },
    {
      path: 'cotacao/:id/resposta',
      name: 'main.cotacao.resposta',
      components: {
        default: () => import(/* webpackChunkName: "resposta" */ '@/modules/cotacoes/resposta/resposta/Resposta.vue'),
      },
    },
    {
      path: 'vendas',
      name: 'main.vendas',
      components: {
        default: () => import(/* webpackChunkName: "vendas" */ '@/modules/vendas/ListagemVendas.vue'),
      },
    },
    {
      path: 'venda/:id',
      name: 'main.vendas.venda',
      components: {
        default: () => import(/* webpackChunkName: "finalizacao" */ '@/modules/vendas/finalizacao/Finalizacao.vue'),
      },
    },
    {
      path: 'minha-conta',
      name: 'main.minha-conta',
      components: {
        default: () => import(/* webpackChunkName: "minha-conta" */ '@/modules/minha-conta/MinhaConta.vue'),
      },
    },
    {
      path: 'minha-empresa',
      name: 'main.minha-empresa',
      components: {
        default: () => import(/* webpackChunkName: "minha-empresa" */ '@/modules/minha-empresa/MinhaEmpresa.vue'),
      },
    },
    {
      path: 'minha-pagina',
      name: 'main.minha-pagina',
      components: {
        default: () => import(/* webpackChunkName: "minha-pagina" */ '@/modules/minha-pagina/MinhaPagina.vue'),
      },
    },
    {
      path: 'usuarios',
      name: 'main.usuarios',
      components: {
        default: () => import(/* webpackChunkName: "usuarios" */ '@/modules/usuarios/Usuarios.vue'),
      },
    },
    {
      path: 'cadastro-usuario',
      name: 'main.usuario.cadastro',
      components: {
        default: () => import(/* webpackChunkName: "cadastro-usuarios" */ '@/modules/usuarios/cadastro/CadastroUsuario.vue'),
      },
    },
    {
      path: 'produtos',
      name: 'main.produtos',
      components: {
        default: () => import(/* webpackChunkName: "produtos" */ '@/modules/produtos/Produtos.vue'),
      },
    },
    {
      path: '/cadastro-produto',
      name: 'main.produto.cadastro',
      components: {
        default: () => import(/* webpackChunkName: "cadastro-produtos" */ '@/modules/produtos/CadastroProduto.vue'),
      },
    },
    {
      path: '/cadastro-produto/:id',
      name: 'main.produto.edicao',
      components: {
        default: () => import(/* webpackChunkName: "edicao-produtos" */ '@/modules/produtos/CadastroProduto.vue'),
      },
      props: true,
    },
    {
      path: 'catalogos',
      name: 'main.catalogos',
      components: {
        default: () => import(/* webpackChunkName: "catalogos" */ '@/modules/catalogos/Catalogos.vue'),
      },
    },
    {
      path: '/cadastro-catalogo',
      name: 'main.catalogo.catalogos',
      components: {
        default: () => import(/* webpackChunkName: "cadastro-catalogos" */ '@/modules/catalogos/CadastroCatalogo.vue'),
      },
    },
    {
      path: '/cadastro-catalogo/:id',
      name: 'main.catalogo.edicao',
      components: {
        default: () => import(/* webpackChunkName: "edicao-catalogos" */ '@/modules/catalogos/CadastroCatalogo.vue'),
      },
    },
    {
      path: 'ofertas',
      name: 'main.ofertas',
      components: {
        default: () => import(/* webpackChunkName: "ofertas" */ '@/modules/ofertas/Ofertas.vue'),
      },
    },
    {
      path: 'ofertas/:id',
      name: 'main.oferta.detalhes',
      components: {
        default: () => import(/* webpackChunkName: "oferta" */ '@/modules/ofertas/detalhes/Oferta.vue'),
      },
    },
    {
      path: '/cadastro-oferta',
      name: 'main.oferta.ofertas',
      components: {
        default: () => import(/* webpackChunkName: "cadastro-oferta" */ '@/modules/ofertas/cadastro/CadastroOferta.vue'),
      },
    },
    {
      path: '/cadastro-oferta/:id',
      name: 'main.oferta.edicao',
      components: {
        default: () => import(/* webpackChunkName: "edicao-oferta" */ '@/modules/ofertas/cadastro/CadastroOferta.vue'),
      },
    },
    {
      path: 'configuracoes-venda',
      name: 'main.configuracoes-venda',
      components: {
        default: () => import(/* webpackChunkName: "configuracao-venda" */ '@/modules/marketplace/configuracoes-venda/ConfiguracoesVenda.vue'),
      },
    },
    {
      path: '/cadastro-configuracoes-venda',
      name: 'main.configuracao-venda.configuracao-venda',
      components: {
        default: () => import(/* webpackChunkName: "cadastro-configuracao-venda" */ '@/modules/marketplace/configuracoes-venda/cadastro/CadastroConfiguracaoVenda.vue'),
      },
    },
    {
      path: '/cadastro-configuracoes-venda/:id',
      name: 'main.configuracao-venda.edicao',
      components: {
        default: () => import(/* webpackChunkName: "edicao-configuracao-venda" */ '@/modules/marketplace/configuracoes-venda/cadastro/CadastroConfiguracaoVenda.vue'),
      },
    },
    {
      path: '/marketplace/configuracoes-frete',
      name: 'main.configuracoes-frete',
      components: {
        default: () => import(/* webpackChunkName: "configuracao-frete" */ '@/modules/marketplace/configuracoes-frete/ConfiguracoesFrete.vue'),
      },
    },
    {
      path: '/cadastro-configuracoes-frete',
      name: 'main.configuracao-frete.configuracao-frete',
      components: {
        default: () => import(/* webpackChunkName: "cadastro-configuracao-frete" */ '@/modules/marketplace/configuracoes-frete/cadastro/CadastroConfiguracaoFrete.vue'),
      },
    },
    {
      path: '/cadastro-configuracoes-frete/:id',
      name: 'main.configuracao-frete.edicao',
      components: {
        default: () => import(/* webpackChunkName: "edicao-configuracao-frete" */ '@/modules/marketplace/configuracoes-frete/cadastro/CadastroConfiguracaoFrete.vue'),
      },
    },
    {
      path: '/marketplace/configuracoes-frete/melhor-envio',
      name: 'main.configuracoes-frete.melhor-envio',
      components: {
        default: () => import(/* webpackChunkName: "configuracao-frete" */ '@/modules/marketplace/configuracoes-frete/CallbackMelhorEnvio.vue'),
      },
    },
    {
      path: '/marketplace/ofertas',
      name: 'main.marketplace.ofertas',
      components: {
        default: () => import(/* webpackChunkName: "ofertas-mktplace" */ '@/modules/marketplace/ofertas/Ofertas.vue'),

      },
    },
    {
      path: '/marketplace/ofertas/edicao-rapida',
      name: 'main.marketplace.ofertas.edicao',
      components: {
        default: () => import(/* webpackChunkName: "ofertas-edicao-rapida" */ '@/modules/marketplace/ofertas/edicao-rapida/OfertaEdicaoRapida.vue'),
      },
    },
    {
      path: '/marketplace/cadastro-oferta',
      name: 'main.marketplace.oferta.cadatro',
      components: {
        default: () => import(/* webpackChunkName: "ofertas-cadastro-mktplace" */ '@/modules/marketplace/ofertas/cadastro/CadastroOferta.vue'),
      },
    },
    {
      path: '/marketplace/cadastro-oferta/:id',
      name: 'main.marketplace.oferta.edicao',
      components: {
        default: () => import(/* webpackChunkName: "ofertas-edicao-mktplace" */ '@/modules/marketplace/ofertas/cadastro/CadastroOferta.vue'),
      },
    },
    {
      path: '/marketplace/ofertas/:id',
      name: 'main.marketplace.oferta.detalhes',
      components: {
        default: () => import(/* webpackChunkName: "oferta-mktplace" */ '@/modules/marketplace/ofertas/detalhes/Oferta.vue'),
      },
    },
    {
      path: '/marketplace/vendas',
      name: 'main.marketplace.vendas',
      components: {
        default: () => import(/* webpackChunkName: "vendas" */ '@/modules/marketplace/compras/Compras.vue'),
      },
    },
    {
      path: '/marketplace/vendas/:id',
      name: 'main.marketplace.venda.detalhes',
      components: {
        default: () => import(/* webpackChunkName: "venda" */ '@/modules/marketplace/compras/detalhes/Compra.vue'),
      },
    },
    {
      path: '/marketplace/grades',
      name: 'main.marketplace.grades',
      components: {
        default: () => import(/* webpackChunkName: "grades" */ '@/modules/marketplace/grades/Grades.vue'),
      },
    },
    {
      path: '/marketplace/cadastro-grade',
      name: 'main.marketplace.grade.cadastro',
      components: {
        default: () => import(/* webpackChunkName: "cadastro-grades" */ '@/modules/marketplace/grades/cadastro/CadastroGrade.vue'),
      },
    },
    {
      path: '/marketplace/grades/:id',
      name: 'main.marketplace.grade.edicao',
      components: {
        default: () => import(/* webpackChunkName: "edicao-grades" */ '@/modules/marketplace/grades/cadastro/CadastroGrade.vue'),
      },
    },
    {
      path: 'indicadores-marketplace',
      name: 'main.indicadores-marketplace',
      components: {
        default: () => import(/* webpackChunkName: "indicadores-marketplace" */ '@/modules/indicadores-marketplace/IndicadoresMarketplace.vue'),
      },
    },
    {
      path: 'dashboard-acessos',
      name: 'main.dashboard-acessos',
      components: {
        default: () => import(/* webpackChunkName: "dashboard-acessos" */ '@/modules/marketplace/dashboard-acessos/DashboardAcessos.vue'),
      },
    },
    {
      path: '/marketplace/alertas',
      name: 'main.marketplace.alertas',
      components: {
        default: () => import(/* webpackChunkName: "alerta-preco" */ '@/modules/marketplace/alertas-preco/AlertaPreco.vue'),
      },
    },
    {
      path: '/marketplace/pendencias',
      name: 'main.marketplace.pendencias',
      components: {
        default: () => import(/* webpackChunkName: "pendencias" */ '@/modules/marketplace/pendencias/Pendencias.vue'),
      },
    },
    ...compraConjunta,
  ],
  beforeEnter: beforeEnterAuth,
};
